import * as React from "react";
import { createRoot } from 'react-dom/client';
import './../public/assets/css/ontario-design-system/styles/ds-theme.min.css';
import { BrowserRouter, Route } from 'react-router-dom';
import { MsalProvider } from "@azure/msal-react";
import NotFound from "./commonComponent/404"; 
import { getEnvVar } from "./config/RuntimeConfig";

console.warn = () => { };
const container = document.getElementById('root');
const root = createRoot(container);

const getRuntimeAppId = () => {
  try {
    const normalized = window.location.pathname.replace('/fr/', '/');
    const parts = normalized.split('/on-form/');
    if (parts.length < 2) {
      return '';
    }
    return parts[1].split('/').filter(Boolean)[0]?.toLowerCase() || '';
  } catch {
    return '';
  }
};

const preloadRuntimeMsalConfig = async () => {
  const appId = getRuntimeAppId();
  const apiBaseUrl = (getEnvVar('LAYOUT_API_URL') || '').replace(/\/+$/, '');
  if (!appId || !apiBaseUrl) {
    return;
  }

  try {
    const response = await fetch(`${apiBaseUrl}/data/admin/get/${appId}`);
    if (!response.ok) {
      return;
    }

    const data = await response.json();
    if (!data?.attachment) {
      return;
    }

    const CircularJSON = await import('circular-json');
    const parsedProgramContainer = CircularJSON.parse(data.attachment);
    const categoryId = parsedProgramContainer?.CategoryId?.toLowerCase?.() || appId;
    const clientId = parsedProgramContainer?.UiAzureRegistration?.trim?.();
    const tenantId = parsedProgramContainer?.UiAzureTenantId?.trim?.();

    if (clientId) {
      sessionStorage.setItem(`msalClientId_${categoryId}`, clientId);
    }
    if (tenantId) {
      sessionStorage.setItem(`msalAuthority_${categoryId}`, `https://login.microsoftonline.com/${tenantId}`);
      sessionStorage.setItem('uiAzureTenantId', tenantId);
    }
  } catch {
    // Fall back to env defaults if bootstrap lookup fails.
  }
};

const bootstrap = async () => {
  await preloadRuntimeMsalConfig();
  await import('./config/axiosConfig');
  const [{ default: msalInstance }, { default: App }] = await Promise.all([
    import('./security/msalInstance'),
    import('./App'),
  ]);

  root.render(
    <MsalProvider instance={msalInstance}>
      <BrowserRouter>
        <Route path={'/on-form/404'} component={NotFound} />
        <App />
      </BrowserRouter>
    </MsalProvider>
  );
};

bootstrap();
